module.exports = __webpack_public_path__ + "assets/img/video-btn-99d36386.png";